import { Component, Input } from 'ng-metadata/core';
import './fav-toggle-icon.component.scss';

/**
 * @ngdoc directive
 * @name mwFavToggleIcon
 * @module mw.components.favToggle
 *
 * @param {boolean} [is-selected=false] - This value will determine the selected state.
 *
 * @description
 * `<mw-fav-toggle-icon>` is a simple favorite icon component that supports two states (selected/not selected) .
 *
 * @usage
 * <hljs hljs-language="html">
 *   <mw-fav-toggle-icon></mw-fav-toggle-icon>
 * </hljs>
 *
 */

@Component({
    selector: 'mw-fav-toggle-icon',
    template: `
        <mw-icon class='mw-fav-toggle-icon' ng-class="{'mw-fav-toggle-icon--selected':$ctrl.isSelected}" svg-icon='toggle:ic_star_24px'>
    `
})
export class FavToggleIconComponent {
    @Input('<') isSelected: boolean = false;

    constructor () {
        'ngInject';
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/fav-toggle/fav-toggle-icon.component.ts